import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCaretRight } from '@fortawesome/free-solid-svg-icons/faSquareCaretRight';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { selectSearchSingleOrderUnvId } from '@pages/orders/store/selectors';
import { setSelectedOrderUnvId } from '@pages/orders/store/slice';



interface GoBackIconProps {
	gobackUrl: string | null,
}


export const GoBackIcon = (props: GoBackIconProps) => {
	const { gobackUrl } = props;

	const searchSingleOrderUnvId = useSelector(selectSearchSingleOrderUnvId);

	const navigate = useNavigate();
	const hasPermission = useHasPermission();
	const dispatch = useDispatch();
	const runSetSelectedOrderUnvId = (orderUnvId: string | null) => dispatch(setSelectedOrderUnvId(orderUnvId));

	const goBackUrlIsOrders = gobackUrl && gobackUrl.startsWith(NavigateRoutesEnum.orders);
	const checkPermission = goBackUrlIsOrders
		? [
			AppRolesEnum.orders_Read
		]
		: [
			AppRolesEnum.redatedOrdersReport_Read,
			AppRolesEnum.reducedOrdersReport_Read,
			AppRolesEnum.reducedMaterialsReport_Read,
			AppRolesEnum.undeliveredOrdersReport_Read
		];

	if (!gobackUrl
		|| gobackUrl.length === 0
		|| gobackUrl === NavigateRoutesEnum.search
		|| !hasPermission(checkPermission))
		return null

	return (
		<FontAwesomeIcon className='goback-icon' icon={faSquareCaretRight} onClick={() => {
			goBackUrlIsOrders && runSetSelectedOrderUnvId(searchSingleOrderUnvId);
			navigate(gobackUrl);
		}}/>
	)
}